/**
 * Asset Service
 *
 * Developed By : Travancore Analytics (2025)
 * Author: [Your Name]
 * Created on: 28/02/2025
 * Project: Vitromed
 * Revision History:
 * SNo.   | Date        | Author              | Task                    | Comments |
 * 1      13/03/2025    Nidhin Sudhakaran     Creating new File
 */

import api from "./api.ts"; 
import Constant from "../global/Constant.ts";

class AssetService {
  /**
   * @param assetData 
   * @returns 
   */
  static async addAsset(assetData: {
    Category: string;
    Type: string;
    Title: string;
    Thumbnail: string; 
    Description: string;
    URL?: string;
    IsHighlighted?: boolean;
    Status?: string;
  }) {
    return api.post(Constant.addAsset, assetData);
  }


  
static async getAssets(page?: number, limit?: number, assetscategory?: string) {
  let url = `${Constant.addAsset}`;
  
  const params = new URLSearchParams();
  if (page) params.append("page", String(page));
  if (limit) params.append("limit", String(limit));
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return api.get(url);
}


static async getAssetsForKnowledgehub(page?: number, limit?: number, assetscategory?: string) {
  let url = `${Constant.addAsset}`;
  
  const params = new URLSearchParams();
  if (page) params.append("page", String(page));
  if (limit) params.append("limit", String(limit));
  params.append("isComplete", "true");
  params.append("categoryOrder", "true"); 

  if (assetscategory) params.append("assetscategory", assetscategory);

  if (params.toString()) {
      url += `?${params.toString()}`;
  }

  return api.get(url);
}


  /**
   * Fetches assets from the backend.
   * @param isHighlighted Optional filter for highlighted assets.
   * @returns List of assets.
   */



  static async getAssetsForHighlights(page?: number, limit?: number, assetscategory?: string) {
    let url = `${Constant.addAsset}`;
    
    const params = new URLSearchParams();
    if (page) params.append("page", String(page));
    if (limit) params.append("limit", String(limit));
    params.append("isComplete", "true");
    params.append("IsHighlighted", "true");
      params.append("categoryOrder", "true"); 

    
    if (assetscategory) params.append("assetscategory", assetscategory);
  
    if (params.toString()) {
        url += `?${params.toString()}`;
    }
  
    return api.get(url);
  }



  /**
   * Updates an existing asset.
   * @param assetId The ID of the asset to update.
   * @param updateData The updated asset data.
   * @returns Response from the backend.
   */
  static async updateAsset(assetId: number, updateData: {
    Title: string;
    Description: string;
    Status: boolean;
    IsHighlighted: boolean;
}) {
    return api.put(`${Constant.addAsset}`, { AssetsID: assetId, ...updateData });
}

  /**
   * Deletes an asset by ID.
   * @param assetId The ID of the asset to delete.
   * @returns Response from the backend.
   */
  static async deleteAsset(assetId: number) {
    return api.delete(`${Constant.addAsset}`, { data: { AssetsID: assetId } });
  }


}
export default AssetService;
